/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2024-02-29 10:29:05
 * @LastEditTime: 2024-10-15 09:46:07
 */

const carrierOrderAPI = {
  // 承运商操作员-运输单列表
  queryCarrierOrderList: {
    method: 'post',
    url: '/logistics/transportOrder/carrier/queryCarrierOrderList',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商查询车辆
  queryCarrierCarlist: {
    method: 'get',
    url: '/logistics/carrier/transport/carlist',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运输任务
  getCarrierTransportOrder: {
    method: 'post',
    url: '/logistics/carrier/transport/getCarrierTransportOrder',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运输任务数量
  getCarrierTransportOrderCount: {
    method: 'get',
    url: '/logistics/carrier/transport/getCarrierTransportOrderCount',
    mask: true // 判断是否需要加载loading框
  },
  // 临时换车
  temporaryTransfer: {
    method: 'post',
    url: '/logistics/order/temporaryTransfer',
    mask: true // 判断是否需要加载loading框
  },
  // 指派车辆
  carrierSchedule: {
    method: 'post',
    url: '/logistics/order/carrierSchedule',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商首页运输任务数量
  queryOrderCountByCarrierAndStatus: {
    method: 'get',
    url: '/logistics/carrier/transport/queryOrderCountByCarrierAndStatus',
    mask: true // 判断是否需要加载loading框
  },
  // "运输单号查询饲料规则
  getFeedSettleRuleItem: {
    method: 'get',
    url: '/logistics/settleRule/querySettleRuleDetailByTransportOrderNo',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商审核确认
  carrierConfirm: {
    method: 'post',
    url: '/logistics/transportOrder/carrier/confirm',
    mask: true // 判断是否需要加载loading框
  },
  // 补充附件
  uploadNodeAndFeeFiles: {
    method: 'post',
    url: '/logistics/transportOrder/driver/uploadNodeAndFeeFiles',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运费结算-查看图片
  queryNewWeightMileagePic: {
    method: 'get',
    url: '/logistics/freightSettle/carrier/queryWeightMileagePic',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运费结算-查看进度
  queryNewPayProcess: {
    method: 'get',
    url: '/logistics/freightSettle/carrier/queryPayProcess',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商首页结算列表
  queryNewFreightSettleList: {
    method: 'post',
    url: '/logistics/freightSettle/carrier/queryFreightSettleList',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运费结算-查看图片
  queryWeightMileagePic: {
    method: 'get',
    url: '/logistics/transportOrder/carrier/queryWeightMileagePic',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商运费结算-查看进度
  queryPayProcess: {
    method: 'get',
    url: '/logistics/transportOrder/carrier/queryPayProcess',
    mask: true // 判断是否需要加载loading框
  },
  // 承运商首页结算列表
  queryFreightSettleList: {
    method: 'post',
    url: '/logistics/transportOrder/carrier/queryFreightSettleList',
    mask: true // 判断是否需要加载loading框
  },
  queryExportFreightSettleList: {
    method: 'post',
    url: '/logistics/freightSettle/carrier/exportFreightSettleList',
    mask: true // 判断是否需要加载loading框
  }
};

export default carrierOrderAPI;



// WEBPACK FOOTER //
// ./src/api/carrierOrder.js